import { useMemo, useState } from "react";
import { WizardStep } from "./wizardStep";
import { FileUpload, wizardStepActionType, wizardStepType } from "../../type";
import { Footer } from "./footer";
import { Container } from "./container";
import { message, showFileConfirmation } from "../../../../components/toast";
import { INVALID_SHEET_NAME, SELECT_A_FILE, SELECT_FILES } from "../../message";
import { useApp } from "../../../../components/app";
import { post } from "../../../../helper/api";
import { getSheetNames } from "../wizardBox/utility";
import { useNavigate } from "react-router-dom";

const WizardBox = (props: any) => {
  const { api, closeAddUpdate, isUpdate, selectedFunction } = props;
  const app = useApp();
  const [currentStep, setCurrentStep] = useState<wizardStepType>(wizardStepType.BrowserFile);
  const [fileUpload, setFileUpload] = useState<FileUpload[]>([]);
  const [FileUploadRefresh, setFileUploadRefresh] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [resetId, setResetId] = useState<string | null>(null);
  let navigate = useNavigate();

  const onFileUpdateRefresh = (status: boolean) => {
    setFileUploadRefresh(status);
  };

  const onFileUpdate = (updatedFiles: FileUpload[]) => {
    setFileUpload(updatedFiles);
    setRefresh(!refresh);
  };

  const fileNeedFunction = useMemo(() => {
    if (!selectedFunction) {
      return [];
    }
    return app.currentApp?.functionList?.filter(
      (x) => x.functionColumns && x.functionColumns.length > 0 && selectedFunction.find((y: any) => y === x.id)
    ) ?? [];
  }, [selectedFunction?.length]);

  const onStepUpdate = async (actionType: wizardStepActionType) => {
    switch (actionType) {
      case wizardStepActionType.next: {
        if (currentStep === wizardStepType.FunctionMap) {
          // Validation for FunctionMap
          if (fileUpload.length > 0) {
            let invalidMap = fileUpload.filter((x) => {
              if (!x.selectedSheet || x.selectedSheet.length <= 0) {
                x.selectedSheet = [{ name: "" }];
              }
              if (!x.selectedSheet![0]?.name && x.totalSheet && x.totalSheet.length === 1) {
                x.selectedSheet[0].name = x.totalSheet[0].name;
              }
              return !x.selectedSheet![0]?.name || !x.selectedSheet![0]?.functionCode;
            });
            if (invalidMap && invalidMap.length > 0) {
              message("error", INVALID_SHEET_NAME);
              return;
            } else if (fileNeedFunction && fileNeedFunction.length > 0) {
              let notMapped = fileNeedFunction.filter(
                (t: any) => !fileUpload.find((x) => x.selectedSheet && x.selectedSheet[0].functionCode === t.functionCode)
              );
              if (notMapped && notMapped.length > 0) {
                message(
                  "error",
                  `You haven't mapped all the required functions. Please make sure to map the following functions: ${notMapped
                    .map((x: any) => x.functionName)
                    .join(",")}`
                );
                return;
              }
            }
            setResetId(null);


            // Api call payload
            const formDataPayload = new FormData();
            const fileListPayload: any[] = [];

            fileUpload.forEach((item: FileUpload) => {
              if (item.file) {
                formDataPayload.append("files", item.file);

                const sheets = item.selectedSheet?.map((sheet: any) => {
                  return {
                    name: sheet.name,
                    functionCode: sheet.functionCode,
                    columnMap: sheet.columnMap?.map((map: any) => ({
                      destinationCode: map.DestinationCode,
                      source: map.Source,
                    })).filter((x: any) => x.source.toString().trim().length > 0),
                  };
                }) ?? [];

                fileListPayload.push({
                  name: item.file.name,
                  sheetList: sheets,
                });
              }
            });

            const values = {
              name: '',
              jobStartWithSubmit: false,
              startDate: new Date().toISOString().split('T')[0],
              endDate: new Date().toISOString().split('T')[0],
            };

            const payload = {
              name: values.name,
              jobStartWithSubmit: values.jobStartWithSubmit,
              fileList: fileListPayload,
              functionList: selectedFunction,
              startDate: values.startDate,
              endDate: values.endDate,
              tenantId: app.conversation?.tenant?.[0]?.id || '',
              isUpdate: false,
            };

            formDataPayload.append("fileList", JSON.stringify(payload));

            const isConfirmed = await showFileConfirmation(fileUpload);

            if (isConfirmed) {
              try {
                // API call below
                const response = await post("/deletebyReference", formDataPayload, undefined, null);
                if (response) {
                  navigate("/job");
                }else{
                   api?.mutate();
                }
                const submittedFiles = fileUpload.map(f => f.file?.name).join(", ");
                // message("success", `Job submitted successfully for: ${submittedFiles}`);
              } catch (error) {
                console.error("Job submission failed:", error);
                message("error", "Failed to submit the job. Please try again.");
              }
            }
            // await post("/job", formDataPayload, undefined, null);
            // // For now, close after alert
            // closeAddUpdate();
          } else {
            setResetId(null);
          }
        } else if (currentStep < wizardStepType.FunctionMap) {
          // Validation for BrowserFile
          switch (currentStep) {
            case wizardStepType.BrowserFile: {
              if (fileUpload.length > 0) {
                if (selectedFunction && selectedFunction.length > 0 && fileUpload.length < fileNeedFunction.length) {
                  message("error", SELECT_FILES.replace("{0}", fileNeedFunction.length.toString()));
                  return;
                }
                setFileUpload(await getSheetNames({ fileUpload }));
                onFileUpdateRefresh(false);
                setResetId(null);
                break;
              } else {
                message("error", SELECT_A_FILE);
                return;
              }
            }
          }
          setCurrentStep(currentStep + 1);
        }
        break;
      }
      case wizardStepActionType.back: {
        if (currentStep > wizardStepType.BrowserFile) {
          setCurrentStep(currentStep - 1);
        }
        break;
      }
    }
  };
 
  return (
    <div className="wizard-box">
      <WizardStep currentStep={currentStep} />
      <Container
        isMultipleFileAllowed={false}
        onFileUpdate={onFileUpdate}
        currentStep={currentStep}
        fileUpload={fileUpload}
        refresh={refresh}
        selectedFunction={selectedFunction}
        onFileUpdateRefresh={onFileUpdateRefresh}
        app={app}
      />
      <Footer
        currentStep={currentStep}
        onStepUpdate={onStepUpdate}
      />
    </div>
  );
};
export { WizardBox };
